import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../../actions';

function RetirementModal({
  retirementApplication,
  id,
  history,
  getItem,
  updating,
  updateList,
  closeModal,
}) {
  const [formData, setFormData] = useState({
    area: '',
    base_line: '',
    no_of_male_employees: '',
    no_of_female_employees: '',
    no_of_employees: '',
    no_of_employees_residing_manila: '',
    no_of_van: '',
    no_of_truck: '',
    no_of_motorcycle: '',
    region_code: '',
    province_code: '',
    municipality_code: '',
    barangay_code: '',
    street: '',
    zip_code: '',
    location_owned: 0,
    with_tax_incentives: 0,
    tdn_no: '',
    pin_no: '',
    tax_incentives_attachment_url: '',
    kind_of_ownership: '',
    owners_gender: '',
    tin_no: '',
    dti_no: '',
    sec_no: '',
    cda_no: '',
    monthly_rental: '',
    business_name: '',
    trade_name: '',
    lessor_name: '',
    cellphone_no: '',
    telephone_no: '',
    email_address: '',
    nationality: '',
    incharge_last_name: '',
    incharge_first_name: '',
    incharge_middle_name: '',
    incharge_suffix_name: '',
    main_office_region_code: '',
    main_office_province_code: '',
    main_office_municipality_code: '',
    main_office_barangay_code: '',
    main_office_street: '',
    main_office_zip_code: '',
    activity_type: '',
    activity_type_others: '',
    pinned_geolocation: '',
    pin_selected: false,
    is_validated: '',

    // veterinary registration
    veterinary_fee_id: '',
    // calculation_details: {},
    activities: [],
    existing_activities: '',
  });

  const [formDataPrevious, setFormDataPrevious] = useState({
    area: '',
    base_line: '',
    no_of_male_employees: '',
    no_of_female_employees: '',
    no_of_employees: '',
    no_of_employees_residing_manila: '',
    no_of_van: '',
    no_of_truck: '',
    no_of_motorcycle: '',
    region_code: '',
    province_code: '',
    municipality_code: '',
    barangay_code: '',
    street: '',
    zip_code: '',
    location_owned: 0,
    with_tax_incentives: 0,
    tdn_no: '',
    pin_no: '',
    tax_incentives_attachment_url: '',
    kind_of_ownership: '',
    owners_gender: '',
    tin_no: '',
    dti_no: '',
    sec_no: '',
    cda_no: '',
    monthly_rental: '',
    business_name: '',
    trade_name: '',
    lessor_name: '',
    cellphone_no: '',
    telephone_no: '',
    email_address: '',
    nationality: '',
    incharge_last_name: '',
    incharge_first_name: '',
    incharge_middle_name: '',
    incharge_suffix_name: '',
    main_office_region_code: '',
    main_office_province_code: '',
    main_office_municipality_code: '',
    main_office_barangay_code: '',
    main_office_street: '',
    main_office_zip_code: '',
    activity_type: '',
    activity_type_others: '',
    pinned_geolocation: '',
    pin_selected: false,
    is_validated: '',

    // veterinary registration
    veterinary_fee_id: '',
    activities: [],
    existing_activities: '',
  });

  const [formDataCalculation, setFormDataCalculation] = useState({});

  const validateForm = useFormValidator(formData, {
    kind_of_ownership: 'required',
    owners_gender:
      'required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=SOLE PROPRIETORSHIP',
    business_name: 'required',
    tin_no: 'required|tin_no',
    // dti_no: 'required_if:kind_of_ownership=SOLE PROPRIETORSHIP|dti_no',
    // sec_no: 'required_if:kind_of_ownership=CORPORATION|sec_no',
    // cda_no: 'required_if:kind_of_ownership=COOPERATIVE|cda_no',

    dti_no: 'required_if:kind_of_ownership=SOLE PROPRIETORSHIP|max_30_char',
    // sec_no: "required_if:kind_of_ownership=CORPORATION|required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|sec_no",
    sec_no:
      'required_if:kind_of_ownership=CORPORATION|required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|max_30_char',
    // cda_no: "required_if:kind_of_ownership=COOPERATIVE|cda_no",
    cda_no: 'required_if:kind_of_ownership=COOPERATIVE|max_30_char',

    cellphone_no: 'required|cellphone_number',
    // telephone_no: 'required|tel_number',
    telephone_no: 'tel_number',
    email_address: 'required|email',
    municipality_code: 'required',
    barangay_code: 'required',
    street: 'required',
    zip_code: 'required|number',
    incharge_first_name: 'required',
    incharge_last_name: 'required',
    nationality:
      'required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|required_if:kind_of_ownership=CORPORATION',
    area: 'required|number',
    base_line: 'required|number',
    no_of_male_employees: 'required|number',
    no_of_female_employees: 'required|number',
    // no_of_employees: 'required|number',
    no_of_employees_residing_manila: 'required|number',
    no_of_van: 'required|number',
    no_of_truck: 'required|number',
    no_of_motorcycle: 'required|number',
    main_office_municipality_code: 'required',
    main_office_barangay_code: 'required',
    main_office_street: 'required',
    main_office_zip_code: 'required|number',
    location_owned: 'required',
    lessor_name: 'required_if:location_owned=0',
    monthly_rental: 'required_if:location_owned=0',
    with_tax_incentives: 'required',
    tax_incentives_attachment_url: 'required_if:with_tax_incentives=1',
    activity_type: 'required',
  });

  const setModal = useContext(ModalContext);

  const calculationDetails = _.get(
    updateList,
    'included.bplsApplication.attributes.calculation_details'
  );

  const handleOnSubmit = e => {
    e.preventDefault();

    Object.keys(formData).forEach(key => {
      if (formData[key] === '' || formData[key] === undefined || formData[key] === null || formData[key] === 0 || formData[key] === false || formData[key] === "[]") {
        delete formData[key];
      }
    });

    return retirementApplication(id, () => {
      setModal({ isOpen: false });
      getItem(id);
      return history.push(`/bpls/applications/retirement/${id}`);
    });
  };

  useEffect(() => {
    if (!_.isEmpty(updateList)) {
      const business = _.get(updateList, 'included.bplsChangeRequests.attributes');

      const bplsActivities = _.get(updateList, "included.bplsChangeRequests.attributes.activities");
      const bplsExistingActivities = _.get(updateList, "included.bplsChangeRequests.attributes.existing_activities");

      setFormData({
        ...formData,
        area: _.get(business, 'area'),
        base_line: _.get(business, 'base_line'),

        no_of_male_employees: _.get(business, 'no_of_male_employees'),
        no_of_female_employees: _.get(business, 'no_of_female_employees'),
        no_of_employees: _.get(business, 'no_of_employees'),
        no_of_employees_residing_manila: _.get(business, 'no_of_employees_residing_manila'),

        no_of_vehicles: _.get(business, 'no_of_vehicles'),
        no_of_van: _.get(business, 'no_of_van'),
        no_of_truck: _.get(business, 'no_of_truck'),
        no_of_motorcycle: _.get(business, 'no_of_motorcycle'),

        region_code: _.get(business, 'region_code'),
        province_code: _.get(business, 'province_code'),
        municipality_code: _.get(business, 'municipality_code'),
        barangay_code: _.get(business, 'barangay_code'),
        street: _.get(business, 'street'),
        zip_code: _.get(business, 'zip_code'),
        location_owned: _.get(business, 'location_owned'),
        with_tax_incentives: !_.isEmpty(
          _.get(business, 'tax_incentives_attachment_url')
        )
          ? 1
          : 0,
        tdn_no: _.get(business, 'tdn_no'),
        pin_no: _.get(business, 'pin_no'),
        tax_incentives_attachment_url: _.get(
          business,
          'tax_incentives_attachment_url'
        ),
        kind_of_ownership: _.get(business, 'kind_of_ownership'),
        owners_gender: _.get(business, 'owners_gender'),
        tin_no: _.get(business, 'tin_no'),
        dti_no: _.get(business, 'dti_no'),
        sec_no: _.get(business, 'sec_no'),
        cda_no: _.get(business, 'cda_no'),
        monthly_rental: _.get(business, 'monthly_rental'),
        business_name: _.get(business, 'business_name'),
        trade_name: _.get(business, 'trade_name'),
        lessor_name: _.get(business, 'lessor_name'),
        cellphone_no: _.get(business, 'cellphone_no'),
        telephone_no: _.get(business, 'telephone_no'),
        email_address: _.get(business, 'email_address'),
        nationality: _.get(business, 'nationality'),
        incharge_last_name: _.get(business, 'incharge_last_name'),
        incharge_first_name: _.get(business, 'incharge_first_name'),
        incharge_middle_name: _.get(business, 'incharge_middle_name'),
        incharge_suffix_name: _.get(business, 'incharge_suffix_name'),
        main_office_region_code:
          _.get(business, 'main_office_region_code'),
        main_office_province_code:
          _.get(business, 'main_office_province_code'),
        main_office_municipality_code:
          _.get(business, 'main_office_municipality_code'),
        main_office_barangay_code:
          _.get(business, 'main_office_barangay_code'),
        main_office_street: _.get(business, 'main_office_street'),
        main_office_zip_code: _.get(business, 'main_office_zip_code'),
        activity_type: _.get(business, 'activity_type'),
        pinned_geolocation:
          _.get(business, 'pinned_geolocation') || '',
        is_validated: _.get(business, 'is_validated'),
        veterinary_fee_id: _.get(business, 'veterinary_fee_id'),
        activities: bplsActivities,
        existing_activities: bplsExistingActivities
      });

      // previous
      const businessPrevious = _.get(updateList, 'included.bplsBusiness.attributes');
      const bplsActivitiesPrevious = _.get(updateList, "included.bplsBusinessActivities");

      setFormDataPrevious({
        ...formDataPrevious,
        area: _.get(businessPrevious, 'area'),
        base_line: _.get(businessPrevious, 'base_line'),

        no_of_male_employees: _.get(businessPrevious, 'no_of_male_employees'),
        no_of_female_employees: _.get(businessPrevious, 'no_of_female_employees'),
        no_of_employees: _.get(businessPrevious, 'no_of_employees'),
        no_of_employees_residing_manila:
          _.get(businessPrevious, 'no_of_employees_residing_manila'),

        no_of_vehicles: _.get(businessPrevious, 'no_of_vehicles'),
        no_of_van: _.get(businessPrevious, 'no_of_van'),
        no_of_truck: _.get(businessPrevious, 'no_of_truck'),
        no_of_motorcycle: _.get(businessPrevious, 'no_of_motorcycle'),

        region_code: _.get(businessPrevious, 'region_code'),
        province_code: _.get(businessPrevious, 'province_code'),
        municipality_code: _.get(businessPrevious, 'municipality_code'),
        barangay_code: _.get(businessPrevious, 'barangay_code'),
        street: _.get(businessPrevious, 'street'),
        zip_code: _.get(businessPrevious, 'zip_code'),
        location_owned: _.get(businessPrevious, 'location_owned'),
        with_tax_incentives: !_.isEmpty(
          _.get(businessPrevious, 'tax_incentives_attachment_url')
        )
          ? 1
          : 0,
        tdn_no: _.get(businessPrevious, 'tdn_no'),
        pin_no: _.get(businessPrevious, 'pin_no'),
        tax_incentives_attachment_url: _.get(
          businessPrevious,
          'tax_incentives_attachment_url'
        ),
        kind_of_ownership: _.get(businessPrevious, 'kind_of_ownership'),
        owners_gender: _.get(businessPrevious, 'owners_gender'),
        tin_no: _.get(businessPrevious, 'tin_no'),
        dti_no: _.get(businessPrevious, 'dti_no'),
        sec_no: _.get(businessPrevious, 'sec_no'),
        cda_no: _.get(businessPrevious, 'cda_no'),
        monthly_rental: _.get(businessPrevious, 'monthly_rental'),
        business_name: _.get(businessPrevious, 'business_name'),
        trade_name: _.get(businessPrevious, 'trade_name'),
        lessor_name: _.get(businessPrevious, 'lessor_name'),
        cellphone_no: _.get(businessPrevious, 'cellphone_no'),
        telephone_no: _.get(businessPrevious, 'telephone_no'),
        email_address: _.get(businessPrevious, 'email_address'),
        nationality: _.get(businessPrevious, 'nationality'),
        incharge_last_name: _.get(businessPrevious, 'incharge_last_name'),
        incharge_first_name: _.get(businessPrevious, 'incharge_first_name'),
        incharge_middle_name: _.get(businessPrevious, 'incharge_middle_name'),
        incharge_suffix_name: _.get(businessPrevious, 'incharge_suffix_name'),
        main_office_region_code:
          _.get(businessPrevious, 'main_office_region_code'),
        main_office_province_code:
          _.get(businessPrevious, 'main_office_province_code'),
        main_office_municipality_code:
          _.get(businessPrevious, 'main_office_municipality_code'),
        main_office_barangay_code:
          _.get(businessPrevious, 'main_office_barangay_code'),
        main_office_street: _.get(businessPrevious, 'main_office_street'),
        main_office_zip_code: _.get(businessPrevious, 'main_office_zip_code'),
        activity_type: _.get(businessPrevious, 'activity_type'),
        pinned_geolocation:
          _.get(businessPrevious, 'pinned_geolocation') || '',
        is_validated: _.get(businessPrevious, 'is_validated'),
        veterinary_fee_id: _.get(businessPrevious, 'veterinary_fee_id'),
        activities: bplsActivitiesPrevious
      });
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(calculationDetails)) {
      setFormDataCalculation({
        ...formDataCalculation,
        ...calculationDetails,
      });
    }
  }, []);

  useEffect(() => {
    validateForm.validate();
    // }, [Object.values(formData)]);
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        {/* Business Activities */}
        {(((_.get(formData, 'activities') === "[]" ? [] : _.get(formData, 'activities') || []).length > 0) || (_.get(formData, 'activity_type') !== null)) && (
          <>
            <div className="row ml-auto font-weight-bold mb-2">
              Business Activities
            </div>
            <div className="container-fluid d-none d-md-block ">
              <div className="row mb-2">
                <div className="col-sm-12 col-md-4 d-flex align-items-center justify-content-center border-left border-top border-bottom p-2">
                  <b className="text-center m-0 cms-text-primary ">Line of Business</b>
                </div>
                <div className="col-sm-12 col-md-2 d-flex align-items-center justify-content-center border-left border-top border-bottom p-2">
                  <b className="text-center m-0 cms-text-primary">
                    Philippine Standard Industrial Code
                  </b>
                </div>
                <div className="col-sm-12 col-md-2 d-flex align-items-center justify-content-center border-left border-top border-bottom p-2">
                  <b className="text-center m-0 cms-text-primary">
                    Products/ Services
                  </b>
                </div>
                <div className="col-sm-12 col-md-2 d-flex align-items-center justify-content-center border-left border-top border-bottom p-2">
                  <b className="text-center m-0 cms-text-primary">No. of Units</b>
                </div>
                <div className="col-sm-12 col-md-2 d-flex align-items-center justify-content-center border-left border-top border-bottom border-right p-2">
                  <b className="text-center m-0 cms-text-primary">
                    Total Capitalization (PH)
                  </b>
                </div>
              </div>
            </div>
            {_.get(formDataPrevious, "activities") !== null && (_.get(formDataPrevious, "activities").map((item) => 
            (
              <div className="form-row">
                <div className="col-sm-12 col-md-4">
                  <input
                    className="form-control"
                    type="text"
                    name="line_of_business"
                    value={_.get(item, "attributes.name") || ""}
                    disabled
                  />
                </div>
                <div className="col-sm-12 col-md-2">
                  <input
                    className="form-control"
                    type="text"
                    name="industrial_code"
                    value={_.get(item, "attributes.industrial_code") || ""}
                    disabled
                  />
                </div>
                {
                  !_.get(item, "attributes.business_line_id") ?
                  (
                    <>
                      <div className="col-sm-12 col-md-2">
                        <input
                          className="form-control"
                          type="text"
                          name="service"
                          value={_.get(item, "attributes.service") || ""}
                          disabled
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <input
                          className="form-control"
                          type="text"
                          name="no_of_units"
                          value={_.get(item, "attributes.no_of_units") || ""}
                          disabled
                        />
                      </div>
                    </>
                  ) : 
                  (
                    <>
                      <div className="col-sm-12 col-md-4">
                        {/* content */}
                        <div className="form-input-group m-1">
                          <ul className="list-group my-2 rounded text-dark">
                            {Object.entries(item.attributes.details).map((detail) => (
                              <li className="list-group-item text-uppercase">
                                <b>{detail[0].replace(/_/g," ")}:</b> {detail[1].replace(/_/g," ")}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </>
                  )
                }
                <div className="col-sm-12 col-md-2">
                  <input
                    className="form-control"
                    type="text"
                    name="capital_amount"
                    value={_.get(item, "attributes.capital_amount") || ""}
                    disabled
                  />
                </div>
                <div className="col-sm-12 col-md-2" />
              </div>
            )))}
              {/* {(_.get(formData, 'activity_type') !== null) && (
                <>
                  <div className="container-fluid">
                    <div className="col-6 form-group">
                      <label htmlFor="last_name" className="form-label mb-0">
                        Activity Type
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        name="no_of_motorcycle"
                        value={_.get(formDataPrevious, 'activity_type')}
                        disabled
                      />
                      {_.get(formDataPrevious, 'activity_type') === 'OTHERS' && (
                        <input
                          className="form-control"
                          type="text"
                          name="no_of_motorcycle"
                          value={_.get(formDataPrevious, 'activity_type_others')}
                          disabled
                        />
                      )}
                    </div>
                  </div>
                </>
              )} */}
          </>
        )}
        <div className="d-flex justify-content-center">
          <button
            disabled={
              updating
            }
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Assess`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>

        </div>
      </form>
    </Modal.Body>
  );
}

RetirementModal.propTypes = {
  retirementApplication: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,


  updating: PropTypes.bool.isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  closeModal: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(RetirementModal);
